import { ExportButton } from '@/common/buttons/ExportButton';
import { PerspectiveTrxLookupViewerGrid } from '@/common/entityFramework/entityPerspective/PerspectiveTrxLookupViewerGrid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { Title } from '@/common/title/Title';
import { DateUtils } from '@/common/utils/DateUtils';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';

// TODO: CHANGE BUTTONS WHEN CLICKS
export const PerspectiveTrxLookupViewer = () => {

  const { navState } = useNavState();
  const module = useModuleFromRoute();

  const [exportReq, setExportReq] = useState();

  const [rightOnOppositeSide, setRightOnOppositeSide] = useState('');
  const [leftOnOppositeSide, setLeftOnOppositeSide] = useState('');

  const reqParam = navState.reqParam;

  // Left file
  const leftViewerReqParam = {
    ...reqParam,
    trxGroup: reqParam.leftTrxGroup,
    oppositeTrxGroup: reqParam.rightTrxGroup,
  };

  // Right file
  const rightViewerReqParam = {
    ...reqParam,
    trxGroup: reqParam.rightTrxGroup,
    oppositeTrxGroup: reqParam.leftTrxGroup,
  };

  const viewerPluginCode = 'PERSPECTIVE_TRX_LOOKUP_VIEWER_PLUGIN';

  const updateExportReq = (partial) => {
    const baseExportReq = {
      timeZoneName: DateUtils.timeZoneName(),
      displayName: `${navState.leftTitle} vs ${navState.rightTitle}`,
      module,
      entity: navState.entity,
      uiType: 'LOOKUP_VIEWER',
      viewerPluginCode,
      leftViewerReqParam,
      rightViewerReqParam,
    };

    setExportReq(prev => ({
      ...baseExportReq,
      ...prev,
      ...partial,
    }));
  };

  const handleLeftOnOppositeSide = (mode) => {
    setLeftOnOppositeSide(prev => (prev === mode ? '' : mode));
  };

  const handleRightOnOppositeSide = (mode) => {
    setRightOnOppositeSide(prev => (prev === mode ? '' : mode));
  };

  const handleBothOnOppositeSide = (mode) => {
    handleRightOnOppositeSide(mode);
    handleLeftOnOppositeSide(mode);
  }

  const clickedStyle = { backgroundColor: '#9ad0b2', color: 'black', border: '1.5px solid black' };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <Title icon={far.faBalanceScale} title={'Compare Transactions'} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} >
          <ExportButton exportReq={exportReq} />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, height: '100%', overflow: 'hidden', m: 0 }}>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>{navState.leftTitle}</Typography>
          <PerspectiveTrxLookupViewerGrid
            viewerReqParam={leftViewerReqParam}
            entity={navState.entity}
            onOppositeSide={leftOnOppositeSide}
            side="left"
            onExportReqChange={updateExportReq}
          />
        </Box>

        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>{navState.rightTitle}</Typography>
          <PerspectiveTrxLookupViewerGrid
            viewerReqParam={rightViewerReqParam}
            entity={navState.entity}
            onOppositeSide={rightOnOppositeSide}
            side="right"
            onExportReqChange={updateExportReq}
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, py: 2, borderTop: '1px solid #eee' }}>
        <Button
          onClick={() => handleLeftOnOppositeSide('false')}
          style={leftOnOppositeSide === 'false' ? clickedStyle : {}}
        >
          Left only
        </Button>
        <Button
          variant="outlined"
          onClick={() => handleBothOnOppositeSide('true')}
          style={
            leftOnOppositeSide === 'true' && rightOnOppositeSide === 'true'
              ? clickedStyle
              : {}
          }
        >
          Matches
        </Button>
        <Button
          onClick={() => handleRightOnOppositeSide('false')}
          style={rightOnOppositeSide === 'false' ? clickedStyle : {}}
        >
          Right only
        </Button>
      </Box>

    </Box>
  );
};